export { default } from "./AnnotationTextArea";
